import { KeyValue } from "@/main/models/common";
import { BrandTypes, BrandActionTypes } from "./brandTypes";
import { PartBrandDomainRequest } from "@/main/models/request";

export function getBrand(request: PartBrandDomainRequest | null = null): BrandActionTypes {
	return {
		type: BrandTypes.GET_BRAND,
		payload: {
			request,
		},
	};
}

export function saveBrand(data: KeyValue[] | null, isError: boolean, errorMessages: string[] | null): BrandActionTypes {
	return {
		type: BrandTypes.SAVE_BRAND,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerBrand(): BrandActionTypes {
	return {
		type: BrandTypes.RESET_REDUCER_BRAND,
	};
}
